import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { homedesignerhighlightSpotList, products_list } from '../services/Product-service';

const COLLECTION_SLOTS = 6;

function mapDesigner(designer) {
    if (!designer?.id) return null;
    const image = designer.designer_cover || designer.designer_thumbnail;
    if (!image) return null;
    return {
        id: `designer-${designer.id}`,
        image,
        name: designer.designer_name || '',
        link: `/category/?designer_id=${designer.id}`,
    };
}

function mapProduct(product) {
    if (!product?.id) return null;
    const image = product.product_thumbail || product.cover_image;
    if (!image) return null;
    return {
        id: `product-${product.id}`,
        image,
        name: product.product_title || product.designer_name || '',
        link: `/products/productdetails/${product.id}`,
    };
}

function DesignSpotlight({
    showdesignspotlight,
    sectionTitle,
    shownewcollections,
    collectionsTitle,
}) {
    const [feature, setFeature] = useState(null);
    const [items, setItems] = useState([]);
    const shouldLoad = showdesignspotlight || shownewcollections;

    useEffect(() => {
        if (!shouldLoad) return;

        // Request one featured designer + up to six more for the right grid.
        homedesignerhighlightSpotList({ limit: COLLECTION_SLOTS + 1 })
            .then((data) => {
                const designers = Array.isArray(data?.designer)
                    ? data.designer
                    : (data?.designer ? [data.designer] : []);
                const products = Array.isArray(data?.data) ? data.data : [];

                const featuredDesigner = mapDesigner(designers[0]);
                const remainingDesignerCards = designers
                    .slice(1)
                    .map(mapDesigner)
                    .filter(Boolean)
                    .slice(0, COLLECTION_SLOTS);

                const productCards = products.map(mapProduct).filter(Boolean);

                let nextFeature = featuredDesigner;
                let productPool = productCards;

                // No designer: fall back to the first product for the spotlight.
                if (!nextFeature && productPool.length > 0) {
                    nextFeature = productPool[0];
                    productPool = productPool.slice(1);
                }

                // Right grid: remaining designers first, then fill gaps with products.
                const needed = COLLECTION_SLOTS - remainingDesignerCards.length;
                const productFill = productPool.slice(0, Math.max(0, needed));
                const nextItems = [...remainingDesignerCards, ...productFill].slice(0, COLLECTION_SLOTS);

                if (nextFeature || nextItems.length > 0) {
                    setFeature(nextFeature);
                    setItems(nextItems);
                    return;
                }

                return products_list({ offset: 0, limit: COLLECTION_SLOTS + 1, sort_by: 'newest' }).then((productData) => {
                    const list = (productData?.products || [])
                        .map(mapProduct)
                        .filter(Boolean);
                    const [first, ...rest] = list;
                    if (!first) return;
                    setFeature(first);
                    setItems(rest.slice(0, COLLECTION_SLOTS));
                });
            })
            .catch((error) => {
                console.error('Error fetching designs in spotlight:', error);
            });
    }, [shouldLoad]);

    const showFeature = showdesignspotlight && !!feature?.image;
    const showCollections = shownewcollections && items.length > 0;

    if (!showFeature && !showCollections) return null;

    return (
        <div className="App">
            <div className="BreakPointContainer">
                <div className="CarouselSectionContainer design-spotlight">
                    <div className={`design-spotlight-layout${!showFeature || !showCollections ? ' is-single' : ''}`}>
                        {showFeature && (
                            <div className="design-spotlight-feature">
                                <div className="SectionTitle">
                                    <h1 className="m-t-0 m-b-15 text-left demi-bold">{sectionTitle || 'DESIGNS IN SPOTLIGHT'}</h1>
                                </div>
                                <Link to={feature.link} className="design-spotlight-feature-link">
                                    <img src={feature.image} alt={feature.name || 'Designs in spotlight'} />
                                    <span className="design-spotlight-overlay">
                                        <span className="design-spotlight-overlay-name demi-bold">
                                            {feature.name}
                                        </span>
                                        <span className="design-spotlight-shop">SHOP NOW</span>
                                    </span>
                                </Link>
                            </div>
                        )}
                        {showCollections && (
                            <div className="design-spotlight-collections">
                                <div className="SectionTitle">
                                    <h1 className="m-t-0 m-b-15 text-left demi-bold">{collectionsTitle || 'NEW COLLECTIONS TO LOVE'}</h1>
                                </div>
                                <div className="design-spotlight-grid">
                                    {items.map((item) => (
                                        <Link to={item.link} className="design-spotlight-card" key={item.id}>
                                            <div className="design-spotlight-card-media">
                                                <img src={item.image} alt={item.name} />
                                            </div>
                                            <div className="h5 demi-bold design-spotlight-name">{item.name}</div>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DesignSpotlight;
